import * as constants from "../constants/constants";

export interface WarehouseState {
    transportAssigneesOptions: any[],
    warehouseClientInformation: any,
    warehouseProducts: any,
    warehouseProductsPagination: any,
    warehouseExtraInformation: any,
    warehouseRecord: any
    warehouseLeftOvers: any
    warehouseInnerStock: any
    warehouseInnerStockPagination: any
    warehouseClients: any
    warehouseClientsPagination: any
    installationAssigneesOptions: any[]
    warehouseInventory: any[]
    warehouseInventoryPagination: any
    warehouseReceiving: any[]
    warehouseReceivingPagination: any
}

const initialState = () => {
    return {
        transportAssigneesOptions: [],
        warehouseClientInformation: null,
        warehouseProducts: [],
        warehouseProductsPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
        warehouseExtraInformation: [],
        warehouseRecord: {},
        warehouseLeftOvers: {},
        warehouseInnerStock: [],
        warehouseInnerStockPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
        warehouseClients: [],
        warehouseClientsPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
        installationAssigneesOptions: [],
        warehouseInventory: [],
        warehouseInventoryPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
        warehouseReceiving: [],
        warehouseReceivingPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
    }
}

const warehouse = (state: WarehouseState = initialState(), action: any) => {
    switch (action.type) {
        case constants.FETCH_TRANSPORT_ASSIGNEES_OPTIONS: {
            return {
                ...state,
                transportAssigneesOptions: action.payload.data[0].user
            };
        }
        case constants?.FETCH_INSTALLATION_ASSIGNEES_OPTIONS: {
            return {
                ...state,
                installationAssigneesOptions: action?.payload.data[0].user
            }
        }
        case constants.FETCH_WAREHOUSE_CLIENT_INFORMATION: {
            return {
                ...state,
                warehouseClientInformation: action.payload.data
            }
        }
        case constants.GET_WAREHOUSE_PRODUCTS: {
            return {
                ...state,
                warehouseProducts: action.payload.data || action.payload,
                warehouseProductsPagination: {
                    currentPage: action.payload.meta?.current_page || action.payload.current_page || 1,
                    lastPage: action.payload.meta?.last_page || action.payload.last_page || 1,
                    perPage: action.payload.meta?.per_page || action.payload.per_page || 20,
                    total: action.payload.meta?.total || action.payload.total || 0
                }
            }
        }
        case constants.GET_WAREHOUSE_INFORMATION: {
            return {
                ...state,
                warehouseExtraInformation: action.payload
            }
        }
        case constants.GET_WAREHOUSE_RECORD: {
            return {
                ...state,
                warehouseRecord: action.payload
            }
        }
        case constants.GET_WAREHOUSE_LEFT_OVERS: {
            return {
                ...state,
                warehouseLeftOvers: action.payload
            }
        }
        case constants.GET_WAREHOUSE_INNER_STOCK: {
            return {
                ...state,
                warehouseInnerStock: action.payload.data || action.payload,
                warehouseInnerStockPagination: action.payload.meta ? {
                    currentPage: action.payload.meta.current_page || 1,
                    lastPage: action.payload.meta.last_page || 1,
                    perPage: action.payload.meta.per_page || 20,
                    total: action.payload.meta.total || 0
                } : state.warehouseInnerStockPagination
            }
        }
        case constants.GET_WAREHOUSE_CLIENTS: {
            return {
                ...state,
                warehouseClients: action.payload.data || action.payload,
                warehouseClientsPagination: action.payload.meta ? {
                    currentPage: action.payload.meta.current_page || 1,
                    lastPage: action.payload.meta.last_page || 1,
                    perPage: action.payload.meta.per_page || 20,
                    total: action.payload.meta.total || 0
                } : state.warehouseClientsPagination
            }
        }
        case constants.GET_WAREHOUSE_INVENTORY: {
            return {
                ...state,
                warehouseInventory: action.payload.data || action.payload,
                warehouseInventoryPagination: action.payload.meta ? {
                    currentPage: action.payload.meta.current_page || 1,
                    lastPage: action.payload.meta.last_page || 1,
                    perPage: action.payload.meta.per_page || 20,
                    total: action.payload.meta.total || 0
                } : state.warehouseInventoryPagination
            }
        }
        case constants.GET_WAREHOUSE_RECEIVING: {
            return {
                ...state,
                warehouseReceiving: action.payload.data || action.payload,
                warehouseReceivingPagination: action.payload.meta ? {
                    currentPage: action.payload.meta.current_page || 1,
                    lastPage: action.payload.meta.last_page || 1,
                    perPage: action.payload.meta.per_page || 20,
                    total: action.payload.meta.total || 0
                } : state.warehouseReceivingPagination
            }
        }
    }
    return state;
}

export default warehouse;